

import React from "react"
import PropTypes from "prop-types"

export default class StandaloneLayout extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      currentView: "API",
    }
  }
  static propTypes = {
    errSelectors: PropTypes.object.isRequired,
    errActions: PropTypes.object.isRequired,
    specActions: PropTypes.object.isRequired,
    specSelectors: PropTypes.object.isRequired,
    layoutSelectors: PropTypes.object.isRequired,
    layoutActions: PropTypes.object.isRequired,
    getComponent: PropTypes.func.isRequired
  }
  
  changeView = (view) => {
    this.setState({ currentView: view})
  }

  render() {
    let { getComponent } = this.props

    let Container = getComponent("Container")
    let Row = getComponent("Row")
    let Col = getComponent("Col")

    
    
    const Topbar = getComponent("Topbar", true)
    const BaseLayout = getComponent("BaseLayout", true)
    const OnlineValidatorBadge = getComponent("onlineValidatorBadge", true)
    const Instructions = getComponent("Instructions", true)
    const HealthDashboard = getComponent("HealthDashboard", true)
    const Incidents = getComponent("Incidents", true)
    const ReleaseNotifications = getComponent("ReleaseNotifications", true)
    const Unsubscribe = getComponent("Unsubscribe", true)
    
    const { currentView } = this.state
		const extraButtons = [
			{
				type: "instructions",
				name: "Instructions",
			},
      {
				type: "healthDashboard",
				name: "Health Dashboard",
			},
			{
				type: "API",
				name: "API",
      },
			{
				type: "releaseNotifications",
				name: "Release Notifications",
      }
		]   
      return (

        <Container className='swagger-ui'>
          {Topbar ? 
          <Topbar 
            currentView={currentView} 
            handleViewChange={this.changeView}
            extraButtons={extraButtons}
          /> 
            : null
          }       
  
          { currentView === "instructions" ?
          <Instructions/> :
          (currentView === "healthDashboard") ? 
          <HealthDashboard 
          currentView={currentView} 
            handleViewChange={this.changeView}
          /> 
            :
          (currentView === "incidents") ? 
          <Incidents/> :
          (currentView === "releaseNotifications") ? 
          <ReleaseNotifications/> :
          (currentView === "unsubscribe") ? 
          <Unsubscribe/> :
          <div className="w-100 h-100">
            <BaseLayout /> 
            <Row>
              <Col>
                <OnlineValidatorBadge />
              </Col>
            </Row>
          </div>
        }
  
        </Container>
      )
  }

}
